import { render, staticRenderFns } from "./ztp-card.vue?vue&type=template&id=757f04c6&scoped=true"
import script from "./ztp-card.vue?vue&type=script&lang=ts"
export * from "./ztp-card.vue?vue&type=script&lang=ts"
import style0 from "./ztp-card.vue?vue&type=style&index=0&id=757f04c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757f04c6",
  null
  
)

export default component.exports